export enum ApplicationResidenceStatus {
  RENTAL = 'Rental',
  OWN = 'Own',
}

export enum ApplicationResidenceInfoType {
  CURRENT = 'Current',
  PREVIOUS = 'Previous',
}

export interface ApplicationResidenceInfoDto {
  id: string;
  type: ApplicationResidenceInfoType;
  status: ApplicationResidenceStatus;
  approvesToContactLandlord: boolean;
  propertyAddress: string | null;
  landlordName: string | null;
  landlordPhone: string | null;
  landlordEmail: string | null;
  monthlyRent: number | null;
  moveInDate: string | null;
  moveOutDate: string | null;
  moveOutReason: string | null;
  createdAt: string;
  updatedAt: string;
}
